<template>
  <BusinessList
  :tabPanelData="tabList"
  pageTypeIn="CONFIRM"
  permission="CONFIRM_BUSINESS"
  businessTypeName="TABLE_COMFIRM_BUSINESS"
  />
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs } from 'vue'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'

export default defineComponent({
  name: 'Comfirmbusiness',
  components: {
    BusinessList
  },
  setup() {
    const dataMap = reactive({
      tabList: [
        { name: '联系人', id: 1 },
        { name: '市场费', id: 4 },
        { name: '跟踪信息', id: 3 }
      ]
    })
    return { ...toRefs(dataMap) }
  }
})
</script>
